import { InspectionAction } from "./action";
import { InspectionState, inspectionState } from "./state";

export function InspectionReducer(state:InspectionState=inspectionState,action:InspectionAction):InspectionState{
    switch(action.type){
        case '@@inspectionState/InitInspectionListAction':
            return {
                ...state,
                inspectionList:action.inspectionList
            }

        case '@@inspectionState/SelectedInspectionAction':

            return {
                ...state,
                selectedInspectionItem:action.inspectionDetail,
                selected_inspection:action.selected_inspection,
           
                selected_inspection_id:action.selected_inspection.inspection_id
            }
        
        case '@@inspectionState/ClearSelectedInspectionAction':
            return {
                ...state,
                selectedInspectionItem:null,
                excelDownloadStartDate:null,
                excelDownloadEndDate:null
            }
        
        case '@@InspectionFormInfoState/ChangeExcelStartDateAction':
            return{
                ...state,
                excelDownloadStartDate: action.date
            }

        case '@@InspectionFormInfoState/ChangeExcelEndDateAction':
            return{
                ...state,
                excelDownloadEndDate: action.date
            }
        case '@@InspectionFormInfoState/initInspectionQuestionAction':
         
             return{
                ...state,
                questionList: action.questionList,
      
            }

            
        case '@@inspectionState/ChangeInspectionQuestionParentIdAction':

            const selected_sub_question_List = state.subQuestionList.filter(sub=>sub.parent_question_id==action.selected_parent_question_id)

            return {
                ...state,
                selected_parent_question_id:action.selected_parent_question_id,
                selected_sub_question_List:selected_sub_question_List
            }
            

        case '@@inspectionState/InitInspectionSubQuestionAction':
            return {
                ...state,
                subQuestionList:action.subQuestionList
            }
    
        case '@@InspectionFormInfoState/ChangeSelectedInspectionAction':
            return {
                ...state,
                selected_inspection:action.selected_inspection
            }
            


            default:
                return state;
            
    }

}

